export const invite = {
    fuwutiaokuan: '《利用規約》',
    yinsizhengce: '《プライバシーポリシー》',
    fzcg: 'コピー成功',
    yqhy: "友達を招待",
    fxlj: "リンクを共有",
    register_now: '今すぐ登録',
    phone: '電話番号',
    email: 'メールアドレス',
    placehold_phone: '電話番号を入力してください',
    placehold_email: 'メールアドレスを入力してください',
    placehold_code: '招待コード',
    argee: '私内容を確認しました、同意します',
    agreement: '《BiKingユーザー規約》',
    register: '登録',
    phone_code: 'SMS認証コード',
    email_code: 'メール認証コード',
    code_to_phone: 'SMS認証コードが送信されました',
    code_to_email: 'メールで認証コードが送信されました',
    has_sent: '認証コードが送信されました：',
    resend: '再送信',
    send_code: '認証コードを送信',
    unable_code: '認証コードを受信できないですか？',
    set_pwd: 'パスワードを設定',
    placehold_pwd: 'パスワードを入力してください',
    submit: '提出',
    error_phone: '正しい電話番号を入力してください',
    error_email: '正しい形式のメールアドレスを入力してください',
    error_checked: '規約に同意するにはチェックを入れてください',
    text: 'パスワードの形式が間違っています。パスワードは8〜32文字で、大文字と小文字のアルファベット、数字を含める必要があります。',
    validate: '認証を完了してください',
    register_success: '登録が成功しました！',
    welcome: 'BiKingへようこそ',
    start_trade: '暗仮想通貨取引を始めるためには入金してください',
    safe: 'さまざまな入金方法で、安全で便利な仮想通貨取引が行えます',
    pay_type: '銀行カードまたは他の支払い方法を使用して、仮想通貨を買い、売ることができます',
    right_now_download: '今すぐダウンロード',
    right_download: 'ダウンロードへ進む',
    'Please_enter_correct_phone_number': '正しい電話番号を入力してください',
    'Referral_code': '招待コードを入力してください',
    'I_have_read_and_agree': '私は内容を確認し、それを同意します',
    'BiKing_User_Agreement': '《BiKingユーザー規約》',
    'Please_enter_password': 'パスワードを入力してください',
    'Email_verification_code': 'メール認証コード',
    'SMS_code': 'SMS認証コード',
    'Incorrect_email_format_please_reenter': '正しい形式のメールアドレスを入力してください',
    'Please_read_and_agree_User_Agreement': 'ユーザー規約を読み、同意してください',
    'Sent_code_to': '認証コードが送信されました：',
zjff: '直接発行！',
ycxdz: '一括で受け取り！',
bbsy: 'ゼロコストで100倍の収益！',
sdly: 'バイキング取引を選ぶ三つの理由',
aqfktx: '世界トップのセキュリティリスク管理システム',
aqhg: '安全で規制順守、信頼性の高い価値ネットワーク、専門の分散型アーキテクチャとDDOS攻撃防止システム',
qqbthyytd: 'グローバルなローカライズ運営チーム',
qqbj: '世界中で展開し、複数の国でローカルサービスを提供し、多様なビジネスエコシステムを構築',
fwtx: 'ユーザー中心のサービス体制の再構築',
yhzs: 'ユーザー最優先、独自の優先支払いメカニズム、ユーザー保護基金の設立',
jslc: 'アンロックプロセス',
zcwcjkjs: '登録が完了すると、1188 USDTがボーナスアカウントの残高として付与され、ボーナスアカウントに入金されます。',
czts: '操作例：登録後、1000 USDTを受け取り、20倍のビットコインレバレッジ注文を購入します。ビットコインが1%上昇した場合、20%の収益、つまり200 USDTを受け取ります。この収益は直接引き出せます。',
zhu: '備考：',
qzlqyky: '1188 USDTは分割して受け取り可能で、すべての種類の契約で使用可能',
gqql: '1188 USDTの有効期間は1ヶ月で、期限切れ時にクリアされます'

}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/ja_JP.js